import { useLanguageContext } from "../../../context/LanguageContext";
import { StyledAltButton, StyledButton } from "../../../styles/ButtonStyles";
import { StyledFlexItem, StyledFlexRow } from "../../../styles/LayoutStyles";
import HiddenLoader from "../../loader/HiddenLoader/HiddenLoader";
import { StyledInputError } from "../../input/wrapper/InputWrapperStyles";
import EVAApiHelper from "../../../helpers/EVAApiHelper";
import { StyledFlowPlayerControls } from "./FlowPlayerControlsStyles";
import { useLoadContext } from "../../../context/LoadContext";
import Form from "../../form/Form";

export default function FlowPlayerControls({
  controller,
  children,
  disabledNavItems = [],
}) {
  const { translate } = useLanguageContext();
  const { isLoading } = useLoadContext();
  const errorMessage = EVAApiHelper.getResponseError(
    "message",
    controller.errors,
  );
  const loadingGroups = [
    "flow_player_next_step",
    "flow_player_previous_step",
    "flow_player_first_step",
  ];
  const disableAll = isLoading(loadingGroups);

  return (
    <StyledFlowPlayerControls
      as={Form}
      onSubmit={() => controller.onNextStep()}
      loadingGroups={loadingGroups}
    >
      {children}

      <StyledFlexRow>
        {/* Cancel Button */}
        {!controller.submitted && controller.onCancelPress && (
          <StyledFlexItem>
            <StyledAltButton
              onClick={() => controller.onCancelPress()}
              disabled={disabledNavItems.includes("cancel") || disableAll}
              style={{ width: "100%" }}
            >
              {translate("eva.frontoffice.general.cancel")}
            </StyledAltButton>
          </StyledFlexItem>
        )}

        {/* Back Button */}
        {!controller.submitted &&
          controller.firstStepId !== controller.step?.id && (
            <HiddenLoader
              groups={"flow_player_previous_step"}
              containerStyle={{ flex: 1 }}
            >
              <StyledAltButton
                onClick={() => controller.onPreviousStep()}
                disabled={disabledNavItems.includes("previous") || disableAll}
                style={{ width: "100%" }}
              >
                {translate("eva.frontoffice.general.back")}
              </StyledAltButton>
            </HiddenLoader>
          )}

        {/* Proceed Button */}
        <HiddenLoader
          groups={"flow_player_next_step"}
          containerStyle={{ flex: 1 }}
        >
          <StyledButton
            type="submit"
            disabled={disabledNavItems.includes("next") || disableAll}
            style={{ width: "100%" }}
          >
            {translate("eva.frontoffice.general.proceed")}
          </StyledButton>
        </HiddenLoader>
      </StyledFlexRow>

      {errorMessage && <StyledInputError>{errorMessage}</StyledInputError>}
    </StyledFlowPlayerControls>
  );
}
